// src/screens/LobbyScreen.jsx
import { T, Btn, Label, Select } from "../components/ui.jsx";

export default function LobbyScreen({
  state, me, onStartGame, onCopyCode, onMafiaChange, onDoctorChange, onQuitRoom,
}) {
  const players     = state.players || [];
  const mafiaCount  = state.lobbyMafia  || 1;
  const doctorCount = state.lobbyDoctor || 1;
  const total       = players.length;
  const citizens    = total - mafiaCount - doctorCount;
  const canStart    = total >= 5 && citizens >= 1;
  const errMsg      = total < 5
    ? `Need at least 5 players. (${total} joined)`
    : citizens < 1
      ? "Not enough citizens. Reduce Mafia or Doctor count."
      : "";

  return (
    <div style={{ ...T.screenTop, paddingTop: "2rem" }}>
      {/* Mini logo */}
      <div style={{ marginBottom: "1.5rem", textAlign: "center" }}>
        <div style={{ ...T.logo, fontSize: "clamp(1.6rem, 5vw, 2.2rem)", marginBottom: 0 }}>
          OMERTÀ
        </div>
      </div>

      {/* Two-column on desktop, single on mobile */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "min(300px, 100%) 1fr",
        gap: "1.25rem",
        width: "100%",
        maxWidth: 880,
      }}>
        {/* LEFT — room code + host config */}
        <div>
          <div style={{ ...T.card, marginBottom: "1rem" }}>
            <div style={T.cardTitle}>Room Code</div>

            {/* Code box */}
            <div
              onClick={onCopyCode}
              title="Click to copy"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "clamp(1.8rem, 6vw, 2.4rem)",
                fontWeight: 900,
                color: "var(--gold)",
                letterSpacing: "0.25em",
                textAlign: "center",
                padding: "0.9rem 0.5rem",
                border: "2px solid rgba(201,168,76,0.35)",
                borderRadius: 3,
                marginBottom: "0.4rem",
                cursor: "pointer",
                userSelect: "all",
                transition: "background 0.2s",
                overflowWrap: "break-word",
                wordBreak: "break-all",
              }}
            >
              {me.roomCode || "------"}
            </div>
            <div style={{ fontSize: "0.58rem", letterSpacing: "0.15em", color: "var(--gold-dim)", textAlign: "center", marginBottom: "1.2rem" }}>
              CLICK TO COPY · SHARE WITH FRIENDS
            </div>

            {me.isHost ? (
              <div>
                <div style={{ marginBottom: "1rem" }}>
                  <Label>Number of Mafia</Label>
                  <Select value={mafiaCount} onChange={(e) => onMafiaChange(+e.target.value)}>
                    {[1, 2, 3].map((n) => <option key={n} value={n}>{n}</option>)}
                  </Select>
                </div>
                <div style={{ marginBottom: "1rem" }}>
                  <Label>Number of Doctors</Label>
                  <Select value={doctorCount} onChange={(e) => onDoctorChange(+e.target.value)}>
                    {[1, 2, 3].map((n) => <option key={n} value={n}>{n}</option>)}
                  </Select>
                </div>

                {/* Role summary grid */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.6rem", marginBottom: "1rem" }}>
                  {[
                    ["Mafia",    mafiaCount,              "rgba(122,20,20,0.08)",  "rgba(122,20,20,0.4)",  "#e05555"],
                    ["Doctors",  doctorCount,             "rgba(26,92,92,0.08)",   "rgba(26,92,92,0.4)",   "#4db8b8"],
                    ["Citizens", Math.max(0, citizens),   null,                    null,                   "var(--gold)"],
                    ["Total",    total,                   null,                    null,                   "var(--gold)"],
                  ].map(([label, val, bg, bdr, color]) => (
                    <div key={label} style={{ textAlign: "center", padding: "0.65rem", border: `1px solid ${bdr || "rgba(201,168,76,0.15)"}`, borderRadius: 2, background: bg || "transparent" }}>
                      <span style={{ fontSize: "0.58rem", letterSpacing: "0.15em", color: "var(--gold-dim)", display: "block", marginBottom: "0.2rem" }}>{label}</span>
                      <span style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.6rem", color }}>{val}</span>
                    </div>
                  ))}
                </div>

                {errMsg && <div style={{ color: "#e05555", fontSize: "0.72rem", marginBottom: "0.75rem" }}>{errMsg}</div>}
                <Btn disabled={!canStart} onClick={onStartGame}>Start Game</Btn>
                <Btn variant="danger" style={{ marginTop: "0.75rem" }} onClick={onQuitRoom}> ✕ Quit Room</Btn>
              </div>
            ) : (
              <div>
                <div style={{ textAlign: "center", padding: "1.5rem 0", color: "rgba(242,234,216,0.35)", fontStyle: "italic", fontSize: "0.82rem", animation: "pulse 1.8s ease-in-out infinite" }}>
                  Waiting for host to start...
                </div>
                <Btn variant="danger" onClick={onQuitRoom}>✕ Leave Room</Btn>
              </div>
            )}
          </div>
        </div>

        {/* RIGHT — player list */}
        <div style={T.card}>
          <div style={T.cardTitle}>
            Players{" "}
            <span style={{ color: "var(--gold-dim)", fontSize: "0.8rem" }}>
              ({total}/10)
            </span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.45rem" }}>
            {players.map((p) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: "0.7rem", padding: "0.55rem 0.85rem", border: "1px solid rgba(201,168,76,0.14)", borderRadius: 2, background: "rgba(255,255,255,0.02)", animation: "slideIn 0.3s ease" }}>
                <div style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--gold)", flexShrink: 0 }} />
                <div style={{ flex: 1, fontSize: "0.88rem" }}>{p.name}</div>
                {p.isHost && (
                  <div style={{ fontSize: "0.52rem", letterSpacing: "0.12em", color: "var(--gold-dim)", border: "1px solid rgba(201,168,76,0.3)", padding: "0.1rem 0.35rem", borderRadius: 1 }}>
                    HOST
                  </div>
                )}
                {p.id === me.id && (
                  <div style={{ fontSize: "0.52rem", letterSpacing: "0.12em", color: "rgba(242,234,216,0.4)", border: "1px solid rgba(242,234,216,0.15)", padding: "0.1rem 0.35rem", borderRadius: 1 }}>
                    YOU
                  </div>
                )}
              </div>
            ))}
            {players.length === 0 && (
              <div style={{ color: "rgba(242,234,216,0.25)", fontSize: "0.8rem", fontStyle: "italic", padding: "1rem 0" }}>
                No players yet...
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile override: stack columns */}
      <style>{`
        @media (max-width: 640px) {
          .lobby-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
